/**
 * TanStack Query `queryOptions()` factories for the user-profile domain,
 * backed by `services/UserService.js`.
 */
import { queryOptions } from '@tanstack/react-query';
import { fetchCurrentUserProfile, fetchUserProfile } from 'services/UserService';
import { fetchFollowedTeams } from 'services/FollowService';

type Id = string | number;

// Queries for "the signed-in user's" data are keyed by that user's id, so a
// different account signing in within the same tab can never be served the
// previous account's cached data. They're disabled while signed out.
export const userQueries = {
    currentProfile: (userId: string | undefined) =>
        queryOptions({
            queryKey: ['users', 'currentProfile', userId],
            queryFn: fetchCurrentUserProfile,
            enabled: Boolean(userId)
        }),

    profile: (userId: Id | undefined) =>
        queryOptions({
            queryKey: ['users', 'profile', userId],
            queryFn: () => fetchUserProfile(userId),
            enabled: Boolean(userId)
        }),

    followedTeams: (userId: string | undefined) =>
        queryOptions({
            queryKey: ['users', 'followedTeams', userId],
            queryFn: fetchFollowedTeams,
            enabled: Boolean(userId)
        })
};
